import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { updateProfile } from "../../../../services/operations/SettingsAPI"
import IconBtn from "../../../common/IconBtn"

const professions = ["Developer", "Designer", "Student", "Teacher", "Other"]

export default function EditProfile() {
  const { user } = useSelector((state) => state.profile)
  const { token } = useSelector((state) => state.auth)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const submitProfileForm = async (data) => {
    try {
      dispatch(updateProfile(token, data))
    } catch (error) {
      console.log("ERROR MESSAGE - ", error.message)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(submitProfileForm)}>
        {/* Profile Information */}
        <div className="my-10 flex flex-col gap-y-6 rounded-xl border-[1px] border-richblack-700 bg-richblack-800 p-8 md:px-12 shadow-lg shadow-richblack-900/40">
          <h2 className="text-xl font-bold text-richblack-5 border-b border-richblack-700 pb-4">
            Profile Information
          </h2>
          
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {/* Display Name / First Name */}
            <div className="flex flex-col gap-2">
              <label htmlFor="firstName" className="lable-style">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                id="firstName"
                placeholder="Enter first name"
                className="form-style"
                {...register("firstName", { required: true })}
                defaultValue={user?.firstName}
              />
              {errors.firstName && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your first name.
                </span>
              )}
            </div>

            {/* Profession */}
            <div className="flex flex-col gap-2">
              <label htmlFor="profession" className="lable-style">
                Profession
              </label>
              <select
                name="profession"
                id="profession"
                className="form-style"
                {...register("profession", { required: true })}
                defaultValue={user?.additionalDetails?.profession}
              >
                {professions.map((ele, i) => (
                  <option key={i} value={ele}>
                    {ele}
                  </option>
                ))}
              </select>
              {errors.profession && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please select your profession.
                </span>
              )}
            </div>

            {/* Date of Birth */}
            <div className="flex flex-col gap-2">
              <label htmlFor="dateOfBirth" className="lable-style">
                Date of Birth
              </label>
              <input
                type="date"
                name="dateOfBirth"
                id="dateOfBirth"
                className="form-style"
                {...register("dateOfBirth", {
                  required: {
                    value: true,
                    message: "Please enter your Date of Birth.",
                  },
                  max: {
                    value: new Date().toISOString().split("T")[0],
                    message: "Date of Birth cannot be in the future.",
                  },
                })}
                defaultValue={user?.additionalDetails?.dateOfBirth}
              />
              {errors.dateOfBirth && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  {errors.dateOfBirth.message}
                </span>
              )}
            </div>

            {/* Gender */}
            <div className="flex flex-col gap-2">
              <label className="lable-style">Gender</label>
              <div className="flex items-center gap-5 form-style">
                {["Male", "Female", "Other"].map((gender) => (
                  <div key={gender} className="flex items-center gap-2">
                    <input
                      type="radio"
                      id={gender}
                      value={gender}
                      {...register("gender", { required: true })}
                      defaultChecked={user?.additionalDetails?.gender === gender}
                      className="accent-yellow-100"
                    />
                    <label htmlFor={gender} className="text-richblack-5 cursor-pointer">
                      {gender}
                    </label>
                  </div>
                ))}
              </div>
              {errors.gender && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please select your gender.
                </span>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="contactNumber" className="lable-style">
                Phone Number
              </label>
              <div className="flex gap-4">
                 <select 
                    className="form-style w-[90px]"
                    {...register("countryCode")}
                 >
                    <option value="+91">+91</option>
                    <option value="+1">+1</option>
                    <option value="+44">+44</option>
                 </select>
                 <input
                    type="tel"
                    name="contactNumber"
                    id="contactNumber"
                    placeholder="12345 67890"
                    className="form-style w-[calc(100%-100px)]"
                    {...register("contactNumber", {
                        required: { value: true, message: "Required" },
                        maxLength: { value: 12, message: "Invalid" },
                        minLength: { value: 10, message: "Invalid" },
                    })}
                    defaultValue={user?.additionalDetails?.contactNumber}
                 />
              </div>
              {errors.contactNumber && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  {errors.contactNumber.message}
                </span>
              )}
            </div>

            {/* About */}
            <div className="flex flex-col gap-2">
              <label htmlFor="about" className="lable-style">
                About
              </label>
              <input
                type="text"
                name="about"
                id="about"
                placeholder="Enter Bio Details"
                className="form-style"
                {...register("about", { required: true })}
                defaultValue={user?.additionalDetails?.about}
              />
              {errors.about && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your Bio.
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={() => { navigate("/dashboard/my-profile") }}
            className="cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-50"
          >
            Cancel
          </button>
          <IconBtn type="submit" text="Save" />
        </div>
      </form>
    </>
  )
}